import { MessageTrayContext, MessageTraySettings } from '@/contexts/message-tray/helpers';
import { useContext } from 'react';

const useMessageTray = () => useContext<MessageTraySettings>(MessageTrayContext);

export default useMessageTray;
